import { useState, useEffect } from 'react'
import { getDropPaymentGroupsAPI } from '../services/dropdown'

function UseDropPaymentGroups() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getDropPaymentGroupsAPI()
      if (!result) return
      if (result.status) {
        const newData = result.result.map((d) => {
          return { ...d, value: d?.paymentGroupId, label: d?.paymentGroupName }
        })

        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])

  return data
}

export default UseDropPaymentGroups
